'use client';

import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { pageTypeAtom } from 'Atoms/App/PageTypeAtom';

export const ClientTasks = () => {
  const setPageType = useSetAtom(pageTypeAtom);

  useEffect(() => {
    setPageType('reviews');
  }, []);

  return undefined;
};
